// @ts-nocheck





import { fetchRequest, initialFetchListParams } from './index';

import { convertFromRubToKop, convertFromKopToRub } from '../pure/unitConversions';

export const convertDataToServer = (data) => ({
  ...data,
  workingHourCost: convertFromRubToKop(data.workingHourCost)
});

export const convertDataFromServer = (data) => ({
  ...data,
  workingHourCost: convertFromKopToRub(data.workingHourCost)
});

export const fetchMaintenanceOperationPrice = async (
params = initialFetchListParams) =>
{
  const maintenanceOperationPrice = await fetchRequest.get(
    '/maintenanceOperationPrice',
    {
      ...initialFetchListParams,
      ...params
    }
  );
  if (maintenanceOperationPrice) {
    return {
      ...maintenanceOperationPrice,
      data: maintenanceOperationPrice.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить прейскурант по видy работ ремонтов');
};

export const getMaintenanceOperationPrice = async (
id) =>
{
  const maintenanceOperationPrice = await fetchRequest.get(
    `/maintenanceOperationPrice/${id}`
  );
  if (maintenanceOperationPrice)
  return convertDataFromServer(maintenanceOperationPrice);
  throw new Error(
    'Не удалось получить информацию по стоимости виду работ для ремонта'
  );
};

export const addMaintenanceOperationPrice = async (
maintenanceOperationPrice) =>
{
  const added = await fetchRequest.post(
    `/maintenanceOperationPrice`,
    convertDataToServer(maintenanceOperationPrice)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось стоимость вида работ');
};

export const updateMaintenanceOperationPrice = async (
maintenanceOperationPrice) =>
{
  const updeted = await fetchRequest.put(
    `/maintenanceOperationPrice`,
    convertDataToServer(maintenanceOperationPrice)
  );
  if (updeted) return convertDataFromServer(updeted);
  throw new Error('Не удалось отредактировать информацию');
};

export const deleteMaintenanceOperationPrice = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/maintenanceOperationPrice/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить запись');
};

export const getActualMaintenanceOperationPrice = async (orgUnitId) => {
  const actualByBranch = await fetchRequest.get(
    `/maintenanceOperationPrice/${orgUnitId}/getActualByBranch`
  );
  if (actualByBranch) return convertDataFromServer(actualByBranch);
  throw new Error('Нет актуального прайслиста за нормо-час работ');
};

export default {
  getActualMaintenanceOperationPrice,
  fetchMaintenanceOperationPrice,
  getMaintenanceOperationPrice,
  addMaintenanceOperationPrice,
  updateMaintenanceOperationPrice,
  deleteMaintenanceOperationPrice
};
